<template src="./main.html"></template>

<script>
import ListaAgenti from "@/components/dialog/ListaAgenti";
import FileFornitori from "@/components/dialog/FileFornitori";
import ListaClienti from "@/components/dialog/ListaClienti";
import LeftBar from "@/components/layout/LeftBar";
import { mapState } from "vuex";
import Wait from "@/plugins/Wait";

import mixin from "@/mixin/styleMixin.js";

export default {
  mixins: [mixin],

  components: {
    ListaAgenti,
    ListaClienti,
    FileFornitori,
    LeftBar,
    Wait,
  },

  data: () => ({
    role: "",
    menu: [],
    offsetTop: 0,

    style: {
      footerFixed: false,
    },
  }),

  methods: {
    async init() {
      try {
        // User info
        let resp = await this.$store.dispatch("user/userInfo");
        this.role = resp.data.Tipologia;
        this.menu = resp.data.Menu;

        // Update
        let url = this.$load.getUrl_Update();
        let resUpdate = await this.$i2kFunctions.checkUpdate(url, false);
        if (resUpdate) this.$toast.update("E' disponibile una nuova versione");
        // -------
      } catch (error) {
        //this.$toast.warning(this.$i2kFunctions.getErrorMsg(error));
        this.$toast.warning("Sessione scaduta");
        this.$store.dispatch("auth/logout");
      }
    },

    onScroll(e) {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
    },

    scrollTop() {
      window.scrollTo(0, 0);
    },

    esci() {
      this.$store
        .dispatch("auth/logout")
        .then(() => { })
        .catch((err) => {
          console.log("app.vue " + err);
        });
    },
  },

  created() {
    this.init();
  },

  mounted() {
    this.$root.$wait = this.$refs.wait;
  },

  computed: {
    dialogAgenti: function () {
      return this.$store.getters["app/getDialog"]("sceltaAgenti");
    },
    dialogClienti: function () {
      return this.$store.getters["app/getDialog"]("sceltaClienti");
    },
    dialogFileFornitori: function () {
      return this.$store.getters["app/getDialog"]("fileFornitori");
    },
    ...mapState({
      loading: (state) => state.app.loading,
      utente: (state) => state.user.user,
      nomeSel: (state) => state.user.userSwitch,
    }),
  },
};
</script>



<style scoped>
/* ----- transition ---- */
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.2s;
}

.fade-enter-active {
  transition-delay: 0.2s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/* ---------- */
</style>
